import { gaTarget } from 'Webapp/shared/app/redux/selectors/analytics';

export default {
  selectors: {
    gaTarget,
  },
};
